<template>
  <realtime-component/>
</template>

<script>
  import RealtimeComponent from '../components/RealtimeComponent'

  export default {
    components: {
      RealtimeComponent
    }
  }
</script>